import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="border-t border-slate-200 bg-white text-slate-500" data-id="element-73" data-mp="3gezdb400vr15">
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-74" data-mp="3gh3q6bfwg0dk">
        <p className="text-xs" data-id="element-75" data-mp="32p5lcct80qn7">© 2026 {productShortName} — All rights reserved.</p>
      </div>
    </footer>;
}